import { render, staticRenderFns } from "./Deactivate.vue?vue&type=template&id=2d13d514"
import script from "./Deactivate.vue?vue&type=script&lang=js"
export * from "./Deactivate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports